/* unplugin-vue-components disabled */import { render } from "./speechTextComp.vue?vue&type=template&id=78424a3a&scoped=true"
import script from "./speechTextComp.vue?vue&type=script&lang=js"
export * from "./speechTextComp.vue?vue&type=script&lang=js"

import "./speechTextComp.vue?vue&type=style&index=0&id=78424a3a&lang=stylus&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78424a3a"]])

export default __exports__